import React, { PropsWithChildren } from 'react';
import { useConfigQuery } from './hooks/useConfigQuery';
import { ConfigContextProvider } from '../../config/ConfigContext';
import { ServiceDisruption, ServiceDisruptionReasonCode } from './service-disrupted';

export function ConfigLoader(props: PropsWithChildren) {
  const { status, data } = useConfigQuery();

  if (status === 'pending') {
    // TODO: Loader/Logo?
    return null;
  }

  if (status === 'error') {
    return (
      <>
        <ServiceDisruption reason={ServiceDisruptionReasonCode.ConfigError} />
      </>
    );
  }

  // Success, continue loading
  return (
    <>
      <ConfigContextProvider value={data}>
        {props.children}
      </ConfigContextProvider>
    </>
  )
}
